import { DataBean } from "../DataBean";

export class FixedAssetGroups extends DataBean {

  public async getFixedAssetGroupsCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getFixedAssetGroupsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteFixedAssetGroups(idfixedassetgroups: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteFixedAssetGroups_Number", [idfixedassetgroups]);
  }

  public async updateFixedAssetGroups(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.FixedAssetGroups_updateFixedAssetGroups_com.orange.finance.processcontract.bean.FixedAssetGroups",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.FixedAssetGroups",
        },
      ]
    );
  }
}
